export const CAREER_CONST = { FREELANCE_CYCLES: 10, INTERN_CYCLES: 6 } as const;
